// Module
var code = `<ex-multi-occurrence-maitre-details-ecran multi-occurrence-options="vm.multiOccurrenceOptions" multi-occurrence-out="vm.MultiOccurrence"> </ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;